import { useEffect } from "react";

const ScrollToTop = () => {
  useEffect(() => {
    document.querySelectorAll('*').forEach(el => {
  if (el.scrollHeight > el.clientHeight) {
    el.scrollTo({ top: 0, behavior: 'smooth' });
  }
});
  }, []);

  return null;
};

export default ScrollToTop;
